module.exports = function() {
  return new Worker("/" + "less-transpiler.6f36ca3d.worker.js");
};